import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/webchat.vue
var o = {
	name: "DtIconWebchat",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--webchat"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Webchat",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M7 5.667a.167.167 0 0 0-.167-.167H2.167A.167.167 0 0 0 2 5.667v4.126l.26-.26a1.25 1.25 0 0 1 .884-.366h3.689A.168.168 0 0 0 7 9V5.667Zm1 1h.856c.332 0 .65.132.884.366l.26.26V3.167A.167.167 0 0 0 9.833 3H5.167A.167.167 0 0 0 5 3.167V4.5h1.833A1.167 1.167 0 0 1 8 5.667v1Zm3 1.23a.75.75 0 0 1-1.28.53l-.687-.687a.251.251 0 0 0-.177-.073H8V9a1.167 1.167 0 0 1-1.167 1.167h-3.69a.251.251 0 0 0-.176.073l-.687.687a.75.75 0 0 1-1.28-.53v-4.73A1.167 1.167 0 0 1 2.167 4.5H4V3.167A1.167 1.167 0 0 1 5.167 2h4.666A1.167 1.167 0 0 1 11 3.167v4.73Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=webchat.js.map